import EspecialidadeModel from "@/models/cadastros/saude/EspecialidadeModel";
import { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";
import Api from "./Api";
import { servicosSaudeApiConfig } from "./config";

class ServicosSaudePrecosApi extends Api {
  constructor(config: AxiosRequestConfig) {
    super(config);
  }

  pesquisarPrecos(filtro: any): Promise<any> {
    return this.get("/precos", {
      params: filtro,
    })
      .then((res) => {
        const { data } = res;
        return data;
      })
      .catch((err) => {
        throw err;
      });
  }

  obterPrecoPorId(idPreco: Number): Promise<any> {
    return this.get(`/precos/${idPreco}`)
      .then((registered: AxiosResponse) => {
        const { data } = registered;
        return data;
      })
      .catch((error: AxiosError) => {
        throw new Error("Falha ao obter preço.");
      });
  }

  deletarPreco(idPreco: Number): Promise<any> {
    return this.delete(`/precos/${idPreco}`)
      .then((registered: AxiosResponse) => {
        const { data } = registered;
        return data;
      })
      .catch((error: AxiosError) => {
        throw new Error(error.response?.data.detail);
      });
  }

  atualizarPreco(idPreco: Number, preco: any): Promise<string> {
    return this.put<any>(`/precos/${idPreco}`, preco)
      .then((registered: AxiosResponse) => {
        const { data } = registered;
        return data;
      })
      .catch((error: AxiosError) => {
        throw new Error(error.response?.data.message);
      });
  }

  salvarPreco(preco: any): Promise<string> {
    return this.post<EspecialidadeModel>("/precos", preco)
      .then((registered: AxiosResponse) => {
        const { data } = registered;
        return data;
      })
      .catch((error: AxiosError) => {
        throw new Error(error.response?.data.message);
      });
  }
}

export const servicosSaudePrecosApi = new ServicosSaudePrecosApi(servicosSaudeApiConfig);
